/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_030: Question = {
  id: 'pres-030-liste-complementaire-especes',
  oldId: '44',
  title: 'Obtention de la liste complémentaire des espèces à statut présentes sur le territoire',
  number: '3.14',
  description: ['La liste des données du CDPNQ est complétée avec des inventaires de terrain, des activités d\'observation citoyenne et les données COSEPAC'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 4,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_030_v2: Question = question_pres_030;
export const question_pres_030_v3: Question = question_pres_030;
